// 🧿 طلسم محافظ فایل
import React from "react";
// Common Components
import { TextInput, Button } from "src/Components";
import Table from "src/Components/Table";
// Requests
import {
  getAssumptionsConfig,
  setAssumptionsConfig,
} from "src/Requests/iMEMarketWatch";
// Utilities
import * as R from "ramda";
import { packetErrorHandler } from "src/Utils/requestUtils";
// Types
import type {
  IAssumptionsParams,
  ISetAssumptionsParams,
} from "src/Interfaces/iMEMarketWatch";

interface IProps {
  onClose: () => void;
}
const AssumptionsModal: React.FC<IProps> = ({ onClose }) => {
  // state
  const [loading, setLoading] = React.useState(false);
  const [searchParam, setSearchParam] = React.useState<IAssumptionsParams>(
    {} as IAssumptionsParams
  );

  React.useEffect(() => {
    setLoading(true);
    getAssumptionsConfig()
      .then((resp) => {
        setSearchParam(resp);
      })
      .catch(packetErrorHandler)
      .finally(() => setLoading(false));
  }, []);

  const searchParamChangeHandler = (name: string, value: any) => {
    setSearchParam({
      ...searchParam,
      [name]: value,
    });
  };

  const baseClusterOneYearGrowthChangeHandler = (name: string, value: any) => {
    setSearchParam({
      ...searchParam,
      baseClusterOneYearGrowth: [
        ...searchParam.baseClusterOneYearGrowth!.map((item) =>
          item.id === name ? { ...item, oneYearGrowthPercent: value } : item
        ),
      ],
    });
  };

  const submit = () => {
    setLoading(true);
    let baseClusterOneYearGrowth: any = {};
    searchParam.baseClusterOneYearGrowth?.forEach((item) => {
      baseClusterOneYearGrowth[item.id] = item.oneYearGrowthPercent;
    });
    const cleanObject = { ...searchParam };
    delete cleanObject.baseClusterOneYearGrowth;
    cleanObject.baseClusterOneYearGrowth = { ...baseClusterOneYearGrowth };

    setAssumptionsConfig(cleanObject)
      .then(onClose)
      .catch(packetErrorHandler)
      .finally(() => setLoading(false));
  };

  return (
    <div className="flex flex-col justify-center items-center">
      <div className="border border-gray-300 rounded p-3 flex flex-col gap-3 !w-full !min-w-full">
        <div className="flex flex-row justify-start items-start gap-3 w-full">
          <div className="w-full">
            <TextInput
              name="coveredCallYTMPercent"
              label="٪ نرخ YTM کاوردکال"
              extraLabel
              onChange={searchParamChangeHandler}
              value={searchParam?.coveredCallYTMPercent?.toString() || ""}
              kind="negativeDecimalNumbers"
            />
          </div>
          <div className="w-full">
            <TextInput
              name="coveredCallHedgePercent"
              label="٪ پوشش ریسک پوزیشن کاوردکال"
              extraLabel
              onChange={searchParamChangeHandler}
              value={searchParam?.coveredCallHedgePercent?.toString() || ""}
              kind="negativeDecimalNumbers"
            />
          </div>
        </div>
        <div className="flex flex-row justify-start items-start gap-3 w-full">
          <div className="w-full">
            <TextInput
              name="rollCallArbitrageCostPercent"
              label="٪ آربیتراژ پرداختی بابت رول کال"
              extraLabel
              onChange={searchParamChangeHandler}
              value={
                searchParam?.rollCallArbitrageCostPercent?.toString() || ""
              }
              kind="negativeDecimalNumbers"
            />
          </div>
          <div className="w-full">
            <TextInput
              name="annualCashReturnPercent"
              label="٪ بازده سالیانه قابل دسترس وجوه نقد"
              extraLabel
              onChange={searchParamChangeHandler}
              value={searchParam?.annualCashReturnPercent?.toString() || ""}
            />
          </div>
        </div>
        <div className="w-full">
          <span className="w-full ml-0 mt-5">٪ رشد یکساله دسته ها</span>
          <div className="flex gap-3 mt-3 mb-6">
            {searchParam?.baseClusterOneYearGrowth?.map((item) => (
              <div key={item.id}>
                <TextInput
                  name={item.id}
                  label={item.name}
                  extraLabel
                  onChange={baseClusterOneYearGrowthChangeHandler}
                  value={item.oneYearGrowthPercent?.toString() || ""}
                  kind="negativeDecimalNumbers"
                />
              </div>
            ))}
          </div>
        </div>
      </div>
      <div className="w-24 mt-3 mr-auto">
        <Button
          onClick={submit}
          text="ثبت"
          variant="contained"
          loading={loading}
        />
      </div>
    </div>
  );
};

export default AssumptionsModal;
